export default "__VITE_ASSET__c69eaa7d__"